import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin, SessionChange } from '@gig/magic-common';
import '@gig/magic-messaging';
import { zendeskChat } from './../../services/live-chat/zendesk/zendesk.service';
import { config } from '../../services';

@Component({
    name: 'zendesk-loader',
})
export default class ZendeskLoaderComponent extends Mixins(MagicConfigMixin) {
    isLoading = false;

    get shouldShowLoader() {
        if (!config?.zendesk) {
            return false;
        }
        return this.isLoading;
    }

    created() {
        if (config?.zendesk) {
            const clear = zendeskChat?.onLoadingStart(() => {
                const checkerId = setInterval(() => {
                    if (zendeskChat?.isLoaded) {
                        this.isLoading = false;
                        clearInterval(checkerId);
                        clear?.();
                    } else if (zendeskChat?.isLoading) {
                        this.isLoading = true;
                    }
                }, 4);
            });
        }
    }

    @SessionChange({ immediate: true })
    onSessionChange() {
        zendeskChat?.login?.();
    }
}
